<po-page-list
  p-title="Solicitação de Compra - APROVAÇÃO"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="tabelaPrincipalHeight"
    [p-sort]="false"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-actions-right="false"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="true"
    p-selectable="true"
    p-hide-select-all="false"
  ></po-table>
  <po-button class="po-sm-6 po-md-6 po-lg-6"
    p-label="Aprovar"
    (p-click)="confirmarDecisao('L')"
  ></po-button>
  <po-button class="po-sm-6 po-md-6 po-lg-6"
    p-label="Rejeitar"
    p-danger="true"
    (p-click)="confirmarDecisao('R')"
  ></po-button>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-input class="po-sm-12 po-md-4 po-lg-4"
      name="CC1NUM"
      p-label="Código"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC1NUM"
      p-clean="true"
    ></po-input>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC1EMISSAO_DE"
      p-label="Emissão de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC1EMISSAO_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC1EMISSAO_ATE"
      p-label="Emissão até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC1EMISSAO_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC1DATPRF_DE"
      p-label="Necessidade de:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC1DATPRF_DE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
      name="DC1DATPRF_ATE"
      p-label="Necessidade até:"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC1DATPRF_ATE"
      [p-iso-format]="formatExtended"
      p-format="dd/mm/yyyy"
    ></po-datepicker>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Usuário Solicitante"
      name="CC1USER_IN"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC1USER_IN"
      p-field-label="CUSRNOME"
      p-field-value="CUSRID"
      [p-columns]="usuarioColumnsFilters"
      [p-field-format]="usuarioLookupService.getFieldFormater"
      [p-filter-service]="usuarioLookupService"
      [p-advanced-filters]="usuarioLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Usuário' }"
      p-multiple="true"
    ></po-lookup>
    <po-lookup class="po-sm-12 po-md-12 po-lg-12"
      p-label="Fornecedor"
      name="CC1FORNECELOJA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC1FORNECELOJA"
      p-field-label="CA2NREDUZ"
      p-field-value="CA2CODLOJA"
      [p-columns]="fornecedorColumnsFilters"
      [p-field-format]="fornecedorLookupService.getFieldFormater"
      [p-filter-service]="fornecedorLookupService"
      [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
      [p-literals]="{ modalTitle: 'Fornecedor' }"
    ></po-lookup>
  </form>
</po-modal>
